module.exports = __webpack_public_path__ + "img/premio7.5b083a39.png";